import type { ChainId } from '@morpho-org/blue-sdk'
import type { Address } from 'viem'

import { useTokenBalance } from '@repo/web3'

import { useWeb3Context } from '@/contexts/Web3Context'
import { useChangeAfterFetching } from '@/hooks/useChangeAfterFetching'

/** Reads the user's V1 vault share balance (MetaMorpho is ERC4626). */
export function useVaultV1Position({
  vaultAddress,
  chainId
}: {
  vaultAddress: Address
  chainId: ChainId | undefined
}) {
  const { account } = useWeb3Context()

  const {
    data: userVaultShares,
    isLoading,
    isFetching,
    error,
    refetch
  } = useTokenBalance({
    chainId,
    userAddress: account.address,
    tokenAddress: vaultAddress,
    refetchInterval: 10_000
  })

  const memoizedError = useChangeAfterFetching(error, isFetching)

  return { userVaultShares, isLoading, error: memoizedError, refetch }
}
